export default __webpack_public_path__ + "static/media/baya-bird-2.8ecb4d60.jpg";